import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const GET_OFFER_INFO_REQUEST = 'GET_OFFER_INFO_REQUEST';
export const GET_OFFER_INFO_SUCCESS = 'GET_OFFER_INFO_SUCCESS';
export const GET_OFFER_INFO_ERROR = 'GET_OFFER_INFO_ERROR';
export const CLEAR_OFFER_INFO = 'CLEAR_OFFER_INFO';

export function getOfferInfoAction() {
	return { type: GET_OFFER_INFO_REQUEST };
}

export function getOfferInfoSuccessAction(dataKey, data) {
	return { type: GET_OFFER_INFO_SUCCESS, dataKey, data };
}

export function getOfferInfoErrorAction(error) {
	return { type: GET_OFFER_INFO_ERROR, error };
}

export function fetchOfferInfoAction(endpoint, body) {
	return dispatch => {
		dispatch(getOfferInfoAction());

		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/3${endpoint}`
			}),
			body
		).then(
			json => dispatch(getOfferInfoSuccessAction(body.dataKey, json['RESPONSE'])),
			err => dispatch(getOfferInfoErrorAction(err))
		);
	};
}

export function clearOfferInfoAction() {
	return dispatch => {
		dispatch({ type: CLEAR_OFFER_INFO });
	};
}
